<template>
    <div class="pageBox">
        <div class="pageFrame">
            <left></left>
            <div class="frame">
                <div class="information">
                    <span class="info_title">个人信息</span>
                    <div class="infoFrame">
                        <!--                        <el-upload-->
                        <!--                            class="avatar_uploader"-->
                        <!--                            action=""-->
                        <!--                            :show-file-list="false"-->
                        <!--                            :on-success="handleAvatarSuccess"-->
                        <!--                            :before-upload="beforeAvatarUpload">-->
                        <div class="avatar_uploader">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        </div>
                        <!--                            <span v-else class="upload">+</span>-->
                        <!--                        </el-upload>-->
                        <span class="phone">账号：{{ loginPhone }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import left from './left'

export default {
    name: "user",
    components: {
        left,
    },
    mounted() {
        document.title = '个人中心' + this.$suffix
        this.$store.commit('modifyUserIndex', 1001)
        if(!this.$noLoginToLogin()){
            this.setUser()
        }
    },
    data() {
        return {
            imageUrl: '',
            loginPhone: ''
        }
    },
    methods: {
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },

        /**
         * 获取头像、登录手机号
         */
        setUser() {
            this.imageUrl = this.$store.state.user.userAvatar
            this.loginPhone = this.$store.state.user.userPhone
        }
    }
}
</script>

<style scoped lang="less">

.pageBox {
    width: 100%;
    background-color: #f9f9f9;

    .pageFrame {
        width: 1210px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        padding: 30px 0px;

        .frame {
            display: flex;
            flex-direction: column;
            width: 880px;
            padding: 40px;
            overflow: hidden;
            background-color: white;

            .information {
                display: flex;
                flex-direction: column;
                margin-bottom: 50px;

                .info_title {
                    font-size: 15px;
                    color: #333;
                    margin-bottom: 20px;
                }

                .infoFrame {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .avatar_uploader {
                        width: 150px;
                        height: 150px;
                        border-radius: 50%;
                        overflow: hidden;
                        background-color: #dcdcdc;
                        margin-right: 40px;
                        box-shadow: 0 0 8px 0 #c2c2c2;

                        ::v-deep .el-upload {
                            width: 150px;
                            height: 150px;
                            overflow: hidden;
                        }

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        .upload {
                            color: white;
                            font-size: 50px;
                            line-height: 150px;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
}
</style>
